var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPlayCircle48Filled = function SvgIconPlayCircle48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.3C14.79 7.3 7.3 14.79 7.3 24c0 9.21 7.49 16.7 16.7 16.7 9.21 0 16.7-7.49 16.7-16.7 0-9.21-7.49-16.7-16.7-16.7Zm6.42 17.73-9.6 5.8A1.2 1.2 0 0 1 19 29.8V18.2c0-.93 1.02-1.51 1.82-1.03l9.6 5.8c.77.47.77 1.59 0 2.05v.01Z",
    fill: "current"
  })));
};
export default SvgIconPlayCircle48Filled;